export const doesPathIncludeBreadcrumbHref = (path, href) => {
  return path?.includes(href)
}
